export const LOTTIES = {
    loader: 'assets/animations/loader.json',
}